export var IdAssetBundleCore;
(function (IdAssetBundleCore) {
    IdAssetBundleCore["Initial"] = "Initial";
    IdAssetBundleCore["CalloutIcons"] = "CalloutIcons";
    IdAssetBundleCore["Animations"] = "Animations";
    IdAssetBundleCore["Outskirts"] = "Outskirts";
    IdAssetBundleCore["Fence"] = "Fence";
    IdAssetBundleCore["Buildings"] = "Buildings";
})(IdAssetBundleCore || (IdAssetBundleCore = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/loading/IdAssetBundleCore.ts
// module id = 125
// module chunks = 3